export default __webpack_public_path__ + "static/media/dexcom.9730664b.png";